export type VehicleListResponse = {
    vehicles: {
        id: string;
        project_id: string;
        name: string;
    }[];
}

export type VehicleArrayResponse = {
    project_id: string;
    vehicle_id: string;
    vehicle_name: string;
}[];

export function isVehicleArrayResponse(res: VehicleListResponse | VehicleArrayResponse): res is VehicleArrayResponse {
    return Array.isArray(res);
}

export type VehicleResponse = {
    vehicle: {
        id: string;
        name: string;
        project_id: string;
    };
} | {
    vehicle_id: string;
    vehicle_name: string;
    project_id: string;
};

